import { defineMessages } from 'react-intl';
import { qubicaBlocks } from '@redturtle/qubicaamf-theme/config/blocks';

import ContainerComponent from '@redturtle/qubicaamf-theme/components/Container/Container';

import TeaserView from '@redturtle/qubicaamf-theme/components/Blocks/Teaser/View';
import IconsAndTextView from '@redturtle/qubicaamf-theme/components/Blocks/IconsAndText/View';
import removeField from '@redturtle/qubicaamf-theme/components/Blocks/extenders/removeField';
import titleSVG from '@plone/volto/icons/text.svg';
import BlockSettingsSchema from '@plone/volto/components/manage/Blocks/Block/Schema';
import EditProductsTitleBlock from '@redturtle/qubicaamf-theme/components/Blocks/Products/Edit';
import ViewProductsTitleBlock from '@redturtle/qubicaamf-theme/components/Blocks/Products/View';
import ImageGalleryTemplate from '@redturtle/qubicaamf-theme/components/Blocks/Listing/ImageGallery/ImageGalleryTemplate';
import DiveInTheSector from '@redturtle/qubicaamf-theme/components/Blocks/Listing/DiveInTheSector/DiveInTheSector';
import {
  MenuConfigurationWidget,
  MenuConfigurationForm,
} from '@redturtle/qubicaamf-theme/widgets';
import { getDropdownMenuNavitems } from '@redturtle/qubicaamf-theme/actions';
import menuSVG from '@plone/volto/icons/menu.svg';
import { RouteCondition } from '@plone/volto/helpers/Slots';
import { ContentTypeCondition } from '@plone/volto/helpers/Slots';

// extenders
import { addCtaFieldset } from '@redturtle/qubicaamf-theme/components/Blocks/extenders/cta';
import addTitleColor from '@redturtle/qubicaamf-theme/components/Blocks/extenders/addTitleColor';
import addBlocksFullWidth from '@redturtle/qubicaamf-theme/components/Blocks/extenders/addBlocksFullWidth';
import addShowAsCard from '@redturtle/qubicaamf-theme/components/Blocks/extenders/addShowAsCard';
import addBlocksBg from '@redturtle/qubicaamf-theme/components/Blocks/extenders/addBlocksBg';
import addBlockLines from '@redturtle/qubicaamf-theme/components/Blocks/extenders/addBlockLines';
import addCardStyles from '@redturtle/qubicaamf-theme/components/Blocks/extenders/addCardStyles';
import addSelectAlternativePreviewImage from '@redturtle/qubicaamf-theme/components/Blocks/extenders/addSelectAlternativePreviewImage';

// block config
import applyCarouselConfig from '@redturtle/qubicaamf-theme/config/carousel';

// reducers
import {
  bowlingcenterproductsicon,
  bowlingcentersearch,
  dropdownMenuNavItemsReducer,
  contactFormInfo,
  qBasesNationList,
  submitContactForm,
  getAppendedResultsQuery,
} from '@redturtle/qubicaamf-theme/reducers';
// slots
import { BlogPageHeader } from '@redturtle/qubicaamf-theme/components/Slots/BlogPageHeader/BlogPageHeader';
import { BlogCategories } from '@redturtle/qubicaamf-theme/components/Slots/BlogCategories/BlogCategories';
import { LatestNews } from '@redturtle/qubicaamf-theme/components/Slots/LatestNews/LatestNews';
import { BlogHomepage } from '@redturtle/qubicaamf-theme/components/Slots/BlogHomepage/BlogHomepage';

// listing
import BowlingCenterCardTemplate from '@redturtle/qubicaamf-theme/components/Blocks/Listing/BowlingCenterCardTemplate';

// widgets
import sizeWidget from '@redturtle/qubicaamf-theme/components/Widgets/sizeWidget';

// views
import VideoView from '@redturtle/qubicaamf-theme/components/View/VideoView/VideoView';
import NationView from '@redturtle/qubicaamf-theme/components/View/NationView/NationView';
import ContactView from '@redturtle/qubicaamf-theme/components/View/ContactView/ContactView';
import QubicaBaseView from '@redturtle/qubicaamf-theme/components/View/QubicaBaseView/QubicaBaseView';
import QubicaBaseFolderView from '@redturtle/qubicaamf-theme/components/View/QubicaBaseFolderView/QubicaBaseFolderView';
import FormView from '@redturtle/qubicaamf-theme/components/View/FormView/FormView';
import NewsTestimonialView from '@redturtle/qubicaamf-theme/components/View/NewsTestimonialsView/NewsTestimonialView';
import NewsMacroView from '@redturtle/qubicaamf-theme/components/View/NewsMacroView/NewsMacroView';
import ContentByTag from '@redturtle/qubicaamf-theme/components/View/ContentByTag/ContentByTag';

import { LinkedinEmbedder } from '@redturtle/qubicaamf-theme/components/AppExtras/LinkedinEmbedder';

import CustomParagraph from '@redturtle/qubicaamf-theme/components/CustomParagraph/CustomParagraph';

const QubicaAmfListingVariations = [
  {
    id: 'bowlingCenterCardTemplate',
    isDefault: false,
    title: 'Bowling center card with image',
    template: BowlingCenterCardTemplate,
  },
];

const applyConfig = (config) => {
  // google recaptcha key
  config.settings.gRecaptchaKey = '6LcALxArAAAAAGz1K3I4MCDNFzDsMggAHwfyyS1S';
  config.settings.apiExpanders = [
    ...config.settings.apiExpanders,
    {
      match: '/contact/find-your-local-representative',
      GET_CONTENT: ['nation'],
      querystring: () => {
        if (typeof window !== 'undefined') {
          const params = new URLSearchParams(window.location.search || '');
          const nation = params.get('nation');
          return {
            'expand.nation': nation,
          };
        }
      },
    },
    {
      match: '/news',
      GET_CONTENT: ['blog_summary'],
    },
  ];
  config.settings.appExtras = [
    ...config.settings.appExtras,
    {
      match: '',
      component: LinkedinEmbedder,
    },
  ];

  config.settings.nonContentRoutes = [
    ...config.settings.nonContentRoutes,
    '/tag',
  ];

  config.addonRoutes = [
    ...config.addonRoutes,
    {
      path: '/news/tag',
      component: ContentByTag,
      // breadcrumbs_title: messages.search_brdc,
    },
  ];
  config.addonReducers.bowlingcenterproductsicon = bowlingcenterproductsicon;
  config.addonReducers.bowlingcentersearch = bowlingcentersearch;
  config.addonReducers.contactFormInfo = contactFormInfo;
  config.addonReducers.qBasesNationList = qBasesNationList;
  config.addonReducers.submitContactForm = submitContactForm;
  config.addonReducers.getAppendedResultsQuery = getAppendedResultsQuery;
  config.registerComponent({
    name: 'Container',
    component: ContainerComponent,
  });
  // Register addon menu config form
  config.registerComponent({
    name: 'MenuConfigurationForm',
    component: MenuConfigurationForm,
  });

  config.settings.slate.elements = {
    ...config.settings.slate.elements,
    p: CustomParagraph,
  };

  config.blocks.blocksConfig = {
    ...config.blocks.blocksConfig,
    productstitle: {
      id: 'productstitle',
      title: 'Products Title',
      icon: titleSVG,
      group: 'text',
      view: ViewProductsTitleBlock,
      edit: EditProductsTitleBlock,
      schema: BlockSettingsSchema,
      restricted: ({ properties, block, contentType }) =>
        contentType !== 'Product' ||
        !!properties.blocks_layout?.items?.find(
          (uid) => properties.blocks?.[uid]?.['@type'] === block.id,
        ),
      mostUsed: false,
      blockHasOwnFocusManagement: true,
      sidebarTab: 0,
      requiredBlocks: 1,
    },
    iconsandtext: {
      ...config.blocks.blocksConfig.iconsandtext,
      view: IconsAndTextView,
      schemaEnhancer: ({ schema, formData, intl }) => {
        addBlocksBg({ schema, formData, intl });
        addBlocksFullWidth({ schema, formData, intl });
        addBlockLines({ schema, formData, intl });

        return schema;
      },
    },
    teaser: {
      ...config.blocks.blocksConfig.teaser,
      view: TeaserView,
      schemaEnhancer: ({ schema, formData, intl }) => {
        addBlocksFullWidth({ schema, formData, intl });
        addShowAsCard({ schema, formData, intl });
        addBlocksBg({ schema, formData, intl });
        addCardStyles({ schema, intl, formData });
        addTitleColor({ schema, formData, intl });
        addBlockLines({ schema, formData, intl });
        addCtaFieldset({ schema, intl });
        addSelectAlternativePreviewImage({ schema, intl });

        return schema;
      },
    },

    search: {
      ...config.blocks.blocksConfig.search,
      schemaEnhancer: ({ schema, formData, intl }) => {
        schema.properties.availableViews.choices =
          config.blocks.blocksConfig.listing.variations.map(({ id, title }) => [
            id,
            title,
          ]);

        schema.properties.facets.schema.fieldsets[0].fields.push(
          'show_counter',
        );

        schema.properties.facets.schema.properties['show_counter'] = {
          title: intl.formatMessage(messages.facets_show_counter),
          type: 'boolean',
        };

        return schema;
      },
    },
    listing: {
      ...config.blocks.blocksConfig.listing,
      variations: [
        ...config.blocks.blocksConfig.listing.variations,
        ...QubicaAmfListingVariations,
      ],
      schemaEnhancer: ({ schema, formData, intl }) => {
        addCtaFieldset({ schema, intl });

        return schema;
      },
    },
    gridBlock: {
      ...config.blocks.blocksConfig.gridBlock,
      schemaEnhancer: ({ schema, formData, intl }) => {
        addBlocksBg({ schema, formData, intl });
        addBlocksFullWidth({ schema, formData, intl });
        return schema;
      },
    },
    ...qubicaBlocks,
  };

  config.blocks.blocksConfig.listing = {
    ...config.blocks.blocksConfig.listing,
    variations: [
      ...config.blocks.blocksConfig.listing.variations.filter(
        (el) => el.id !== 'imageGallery',
      ),
      {
        id: 'imageGallery',
        title: 'Image Gallery',
        template: ImageGalleryTemplate,
        schemaEnhancer: ({ schema, formData, intl }) => {
          schema.fieldsets[0].fields = [
            ...schema.fieldsets[0].fields,
            'full_width',
            'show_title',
            'show_description',
          ];

          schema.properties.full_width = {
            title: intl.formatMessage(messages.full_width_block_title),
            type: 'boolean',
          };

          schema.properties.show_title = {
            title: intl.formatMessage(messages.show_slides_title),
            type: 'boolean',
          };
          schema.properties.show_description = {
            title: intl.formatMessage(messages.show_slides_description),
            type: 'boolean',
          };
          return schema;
        },
      },
      {
        id: 'diveInTheSector',
        title: 'Dive in the Sector',
        template: DiveInTheSector,
        schemaEnhancer: ({ schema, formData, intl }) => {
          addBlocksBg({ schema, formData, intl });
          addBlocksFullWidth({ schema, formData, intl });
          // TODO: Needed??
          addBlockLines({ schema, formData, intl });

          return schema;
        },
      },
    ],
  };

  config.blocks.blocksConfig.gridBlock.allowedBlocks.push('calltoaction');
  config.blocks.blocksConfig.gridBlock.allowedBlocks.push('gridBlock');
  config.blocks.blocksConfig.gridBlock.blocksConfig.calltoaction =
    config.blocks.blocksConfig.calltoaction;

  config.blocks.blocksConfig.gridBlock.allowedBlocks.push('cardwithimages');
  config.blocks.blocksConfig.gridBlock.blocksConfig.cardwithimages =
    config.blocks.blocksConfig.cardwithimages;

  config.blocks.blocksConfig.gridBlock.blocksConfig.teaser =
    config.blocks.blocksConfig.teaser;

  config.blocks.blocksConfig.search.variations =
    config.blocks.blocksConfig.search.variations.filter(
      (variation) => variation.id === 'facetsLeftSide',
    );

  config.blocks.blocksConfig.search.variations[0].isDefault = true;

  config.blocks.initialBlocks = {
    ...config.blocks.initialBlocks,
    Product: [
      { '@type': 'productstitle', fixed: true, required: true },
      { '@type': 'leadimage', fixed: true, required: true },
    ],
    ProductSection: [{ '@type': 'productstitle', fixed: true, required: true }],
    PortfolioBowlingCenter: [
      { '@type': 'bowlingcenterheader', fixed: true, required: true },
      { '@type': 'title', fixed: true, required: true },
      { '@type': 'bowlingcenterdescription', fixed: true, required: true },
    ],
    'News Item': [
      { '@type': 'title', fixed: true, required: true },
      { '@type': 'leadimage', fixed: true, required: false },
    ],
    Testimonial: [{ '@type': 'slate', fixed: true, required: false }],
  };

  const removable_blocks = ['title'];
  config.blocks.requiredBlocks = config.blocks.requiredBlocks.filter(
    (item) => !removable_blocks.includes(item),
  );

  // Megamenu config
  config.widgets.id = {
    ...config.widgets.id,
    menu_configuration: MenuConfigurationWidget,
  };

  config.widgets.widget = {
    ...config.widgets.widget,
    size_widget: sizeWidget,
  };

  config.addonReducers = {
    ...config.addonReducers,
    dropdownMenuNavItems: dropdownMenuNavItemsReducer,
  };

  config.settings.asyncPropsExtenders = [
    ...(config.settings.asyncPropsExtenders ?? []),
    {
      path: '/',
      extend: (dispatchActions) => {
        if (
          dispatchActions.filter(
            (asyncAction) => asyncAction.key === 'dropdownMenuNavItems',
          ).length === 0
        ) {
          dispatchActions.push({
            key: 'dropdownMenuNavItems',
            promise: ({ location, store: { dispatch } }) =>
              __SERVER__ && dispatch(getDropdownMenuNavitems()),
          });
        }
        return dispatchActions;
      },
    },
  ];

  config.settings.controlPanelsIcons['dropdown-menu-settings'] = menuSVG;
  config.settings.navDepth = 3;
  config.settings['volto-dropdownmenu'] = {
    options: {
      clickableNavigationRoots: false, //if true, a checkbox option in dropdown menu appears
    },
  };
  // End megamenu config

  // Volto-editor templates config, add excluded blocks from template editor here
  config.settings['volto-editor-templates'].excludeBlocksFromTemplates = [
    ...(config.settings['volto-editor-templates'].excludeBlocksFromTemplates ??
      []),
    // 'blockname',
  ];

  // contenttype views
  config.views.contentTypesViews = {
    ...config.views.contentTypesViews,
    WildcardVideo: VideoView,
    Nation: NationView,
    Contact: ContactView,
    QubicaBase: QubicaBaseView,
    QubicaBaseFolder: QubicaBaseFolderView,
    'News Item': NewsTestimonialView,
    Testimonial: NewsTestimonialView,
    NewsMacroType: NewsMacroView,
  };

  config.views = {
    ...config.views,
    layoutViews: {
      ...config.views.layoutViews,
      form_view: FormView,
    },
    layoutViewsNamesMapping: {
      ...config.views.layoutViewsNamesMapping,
      form_view: 'Form view',
    },
  };

  // Remove tags from belowContent
  config.unRegisterSlotComponent('belowContent', 'tags', 1);
  // Additional slots registration
  config.registerSlotComponent({
    slot: 'aboveContent',
    name: 'headernav',
    component: BlogPageHeader,
    predicates: [
      RouteCondition('/news'),
      ContentTypeCondition([
        'News Item',
        'Testimonial',
        'Blog',
        'NewsMacroType',
      ]),
    ],
  });
  config.registerSlotComponent({
    slot: 'aboveContent',
    name: 'headercategories',
    component: BlogCategories,
    predicates: [
      RouteCondition('/news/**'),
      ContentTypeCondition(['News Item', 'Testimonial']),
    ],
  });
  config.registerSlotComponent({
    slot: 'aboveContent',
    name: 'blogHomepage',
    component: BlogHomepage,
    predicates: [RouteCondition('/news', true), ContentTypeCondition(['Blog'])],
  });
  config.registerSlotComponent({
    slot: 'blogRightPortlet',
    name: 'blogRightPortlet',
    component: LatestNews,
    predicates: [
      RouteCondition('/news/**'),
      ContentTypeCondition(['News Item', 'Testimonial']),
    ],
  });

  //slider settings
  applyCarouselConfig(config);

  return config;
};

export default applyConfig;

const messages = defineMessages({
  cta_fieldset_title: {
    id: 'redturtle__volto-blocks__cta_fieldset_title',
    defaultMessage: 'Call to action',
  },
  // copied from core listing block
  LinkTitle: {
    id: 'Link title',
    defaultMessage: 'Link Title',
  },

  cta_title_default: {
    id: 'redturtle__volto-blocks__cta_title_default',
    defaultMessage: 'Read more',
  },
  Title: { id: 'Title', defaultMessage: 'Title' },
  Description: { id: 'Description', defaultMessage: 'Description' },
  Slides: { id: 'Slides', defaultMessage: 'Slides' },
  slide_image: { id: 'slide_image', defaultMessage: 'Image' },
  slide_description: { id: 'slide_description', defaultMessage: 'Description' },
  slide_link: { id: 'slide_link', defaultMessage: 'Link' },
  slide_link_more_title: {
    id: 'slide_link_more_title',
    defaultMessage: 'Link text',
  },
  slide_link_more_description: {
    id: 'slide_link_more_description',
    defaultMessage:
      'If provided, the link text will be shown when hovering on the image',
  },
  facets_show_counter: {
    id: 'facets_show_counter',
    defaultMessage: 'Show filter counter',
  },
  full_width_block_title: {
    id: 'full_width_block_title',
    defaultMessage: 'Show block as full-width',
  },
  show_slides_title: {
    id: 'show_slides_title',
    defaultMessage: 'Show slides title',
  },
  show_slides_description: {
    id: 'show_slides_description',
    defaultMessage: 'Show slides description',
  },
  emphasize_first_item: {
    id: 'emphasize_first_item',
    defaultMessage: 'Emphasize the first item',
  },
});
